import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/app/programs/$programId/organizations/$organizationId/sets/$setId/glossary',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: `/app/organizations/${params.organizationId}/sets/${params.setId}/glossary`,
    })
  },
})
